import { render, staticRenderFns } from "./ContentTransformComponent.vue?vue&type=template&id=359cca83&scoped=true"
import script from "./ContentTransformComponent.vue?vue&type=script&lang=js"
export * from "./ContentTransformComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentTransformComponent.vue?vue&type=style&index=0&id=359cca83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cca83",
  null
  
)

export default component.exports